$(document).ready(function() {
  $('.checkoutbtn').click(function(event) {
    var selectedValue = $('input[name="attributes[product_guides]"]:checked').val();
    if (!selectedValue) {
      event.preventDefault();
      alert('Please choose if you want product guides');
    }
  });

  $('.list-view-item__title a:contains("Route Package Protection")').each(function() {
  $(this).text($(this).text().replace('Route Package Protection', 'PACKAGE PROTECTION'));
});


    $('a.grid-view-item__link.grid-view-item__image-container .h4.grid-view-item__title:contains("Route Package Protection")').each(function() {
  $(this).text($(this).text().replace('Route Package Protection', 'PACKAGE PROTECTION'));
});

    $('h1.product-single__title:contains("Route Package Protection")').each(function() {
  $(this).text($(this).text().replace('Route Package Protection', 'PACKAGE PROTECTION'));
});
  

  

  
});


document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('.grid.grid--view-items');
  if (grid) {
    const items = grid.querySelectorAll('.grid__item');
    if (items.length === 3) {
      grid.classList.add('three-items');

      // Hide pagination if it exists
      const pagination = document.querySelector('ul.list--inline.pagination');
      if (pagination) {
        pagination.style.display = 'none';
      }
    }
  }
});
